import Icon from '@mdi/react';
import { mdiLinkedin, mdiFacebook, mdiGithub, mdiInstagram } from '@mdi/js';

export default function Footer(){
    return(
        <footer className="footer--container">
            <hr className="divider" />
            <div className='footer-block'>
                <div className="flex social-icons">
                    <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/karthicnpt.j/'><Icon className='icon' path={mdiFacebook} size={1.5} color="black" /></a>
                    <a target='_blank' rel='noopener noreferrer' href='https://www.linkedin.com/in/karthick-jayakumar-bb069273/'><Icon className='icon' path={mdiLinkedin} size={1.5} color="black" /></a>
                    <a target='_blank' rel='noopener noreferrer' href='https://github.com/jaikartick'><Icon className='icon' path={mdiGithub} size={1.5} color="black" /></a>
                    <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/karthy_js/'><Icon className='icon' path={mdiInstagram} size={1.5} color="black" /></a>
                </div>
                <div className="info">
                    <div className="footnote">
                        KARTHICK JAYAKUMAR <span className="highlight">©2024</span>
                    </div>
                </div>
            </div>
        </footer>
    )
}